import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AasService } from 'src/app/areas/fam/views/aas/aas.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';

@Component({
  selector: 'app-sw-header-download-task',
  templateUrl: './sw-header-download-task.component.html',
  styleUrls: ['./sw-header-download-task.component.css']
})
export class SwHeaderDownloadTaskComponent implements OnInit {

  @Output() callback = new EventEmitter();
  @Input() param: any;
  @ViewChild('modal') modal: SwModalframeComponent;
  @ViewChild('detailModal') detailModal: SwModalframeComponent;

  taskList: any[] = [];
  detailText: string = '';
  detailLines: any[] = [];
  isLoading: boolean = false;
  /** 文件中心任务名称和状态查询条件。 */
  queryCondition: any = {
    taskName: '',
    taskStatus: ''
  };
  pageBase: any = {
    current: 1,
    size: 10,
    total: 0,
    pages: 0
  };

  constructor(
    private service: AasService,
    private message: SwMassageBoxService
  ) { }

  ngOnInit() {
    this.queryTaskList();
  }

  /**
   * 查询当前登录人的下载和批量导入任务列表。
   * @returns 更新文件中心分页列表数据
   */
  queryTaskList() {
    this.isLoading = true;
    const taskName = (this.queryCondition.taskName || '').trim();
    var param = {
      entity: {
        taskName: taskName,
        taskStatus: this.queryCondition.taskStatus || ''
      },
      param: {
        pageNum: this.pageBase.current,
        pageSize: this.pageBase.size
      }
    };
    this.service.queryDownloadTaskList(param).subscribe(res => {
      this.isLoading = false;
      if (res.code == 200) {
        this.setPageData(res.data);
      } else {
        this.message.danger(res.msg || res.message || '查询文件中心任务失败');
      }
    }, () => {
      this.isLoading = false;
      this.message.danger('查询文件中心任务失败');
    });
  }

  /**
   * 点击查询按钮刷新下载任务列表。
   * @returns 回到第一页并重新查询未过期任务数据
   */
  search() {
    this.pageBase.current = 1;
    this.queryTaskList();
  }

  /**
   * 切换下载任务分页。
   * @param event 分页组件返回的页码和每页数量
   * @returns 根据分页条件重新查询任务列表
   */
  pageChange(event) {
    this.pageBase = event || this.pageBase;
    this.queryTaskList();
  }

  /**
   * 设置分页数据，兼容后端分页对象和旧数组返回。
   * @param data 后端返回的下载任务分页对象或数组
   * @returns 更新列表和分页状态
   */
  setPageData(data) {
    if (data && data.records) {
      this.taskList = data.records || [];
      this.pageBase = data;
      return;
    }
    this.taskList = data || [];
    this.pageBase.total = this.taskList.length;
    this.pageBase.pages = this.pageBase.size > 0 ? Math.ceil(this.taskList.length / this.pageBase.size) : 0;
  }

  /**
   * 下载已完成任务文件。
   * @param task 下载任务记录
   * @returns 打开后端校验后的nginx下载地址
   */
  download(task) {
    if (!task || task.taskStatus != 'SUCCESS') {
      return;
    }
    this.service.downloadTaskFile(task.taskId).subscribe(res => {
      if (res.code == 200 && res.data) {
        this.triggerFileDownload(res.data);
      } else {
        this.message.danger(res.message || '下载任务尚未完成');
      }
    });
  }

  /**
   * 使用隐藏iframe触发文件下载，避免覆盖当前系统页面。
   * @param url 后端校验后的文件下载地址
   */
  triggerFileDownload(url) {
    var elemIF = document.createElement('iframe');
    elemIF.src = url;
    elemIF.style.display = 'none';
    document.body.appendChild(elemIF);
    setTimeout(() => {
      document.body.removeChild(elemIF);
    }, 3000);
  }

  /**
   * 格式化文件大小。
   * @param size 文件字节数
   * @returns 便于页面展示的文件大小
   */
  formatSize(size) {
    if (!size && size !== 0) {
      return '-';
    }
    if (size < 1024) {
      return size + 'B';
    }
    if (size < 1024 * 1024) {
      return (size / 1024).toFixed(1) + 'KB';
    }
    if (size < 1024 * 1024 * 1024) {
      return (size / 1024 / 1024).toFixed(1) + 'MB';
    }
    return (size / 1024 / 1024 / 1024).toFixed(1) + 'GB';
  }

  /**
   * 转换文件中心任务状态文案。
   * @param status 后端任务状态
   * @param taskType DOWNLOAD或BATCH_IMPORT
   * @returns 中文状态文案
   */
  getStatusText(status, taskType) {
    if (status == 'WAITING') {
      return '等待中';
    }
    if (status == 'RUNNING') {
      return taskType == 'BATCH_IMPORT' ? '处理中' : '打包中';
    }
    if (status == 'SUCCESS') {
      return '已完成';
    }
    if (status == 'FAILED') {
      return '失败';
    }
    if (status == 'PARTIAL_SUCCESS') {
      return '部分成功';
    }
    if (status == 'EXPIRED') {
      return '已过期';
    }
    return status || '-';
  }

  /**
   * 转换文件中心任务类型。
   * @param taskType 后端任务类型
   * @returns 中文任务类型
   */
  getTaskTypeText(taskType) {
    return taskType == 'BATCH_IMPORT' ? '批量导入' : '下载';
  }

  /**
   * 转换批量导入业务类型。
   * @param businessType 后端业务类型枚举
   * @returns 中文业务名称
   */
  getBusinessTypeText(businessType) {
    const names = {
      EXPLORATION: '探方',
      RUINS: '遗迹',
      LAYER: '地层',
      RELICS: '遗物',
      TILES: '小件',
      SAMPLE: '样品',
      SPECIMEN: '标本',
      FLOTATION: '浮选'
    };
    return businessType ? (names[businessType] || businessType) : '-';
  }

  /**
   * 展示批量导入统计、逐编号明细或下载任务错误信息。
   * @param task 文件中心任务记录
   */
  showDetail(task) {
    if (!task) {
      return;
    }
    const details = [];
    if (task.remark) {
      details.push(task.remark);
    }
    if (task.errorMessage && task.remark && task.remark.indexOf(task.errorMessage) < 0) {
      details.push('错误信息：\n• ' + task.errorMessage);
    } else if (task.errorMessage && !task.remark) {
      details.push('错误信息：\n• ' + task.errorMessage);
    }
    this.detailText = details.length > 0 ? details.join('\n') : '当前任务暂无详情';
    this.detailLines = this.buildDetailLines(this.detailText);
    if (this.detailModal) {
      this.detailModal.toggle();
    }
  }

  /**
   * 将任务详情文本转换为标题、分组标题和项目符号行，避免直接注入HTML。
   * @param detailText 后端返回的批量导入备注或下载任务错误信息
   * @returns 文件中心详情弹窗的安全展示行
   */
  buildDetailLines(detailText: string) {
    const result = [];
    const lines = (detailText || '').split(/\r?\n/);
    lines.forEach(item => {
      const text = (item || '').trim();
      if (!text) {
        return;
      }
      let type = 'text';
      if (text.indexOf('导入完成') === 0) {
        type = 'title';
      } else if (text.charAt(text.length - 1) === '：') {
        type = 'section-title';
      } else if (text.indexOf('•') === 0) {
        type = 'item';
      }
      result.push({ text: text, type: type });
    });
    return result;
  }

  /**
   * 关闭任务详情弹窗。
   * @returns 保留文件中心列表弹窗并隐藏详情
   */
  closeDetail() {
    if (this.detailModal) {
      this.detailModal.toggle();
    }
  }

  /**
   * 关闭文件中心弹窗。
   * @returns 通知动态组件服务销毁当前组件
   */
  close() {
    if (this.modal) {
      this.modal.toggle();
    }
    this.callback.emit();
  }
}

